import { analytics as algoliaAnalytics } from 'instantsearch.js/es/widgets';
import merge from 'lodash/merge';

export const algoliaGtmAdapter = (searchClient, event = 'itemSearch') => {
  const { dataLayer = [] } = window;
  searchClient.addWidgets([
    algoliaAnalytics({
      pushFunction(formattedParameters, state, results) {
        const { facetsRefinements, disjunctiveFacetsRefinements } = state;
        dataLayer.push({
          event,
          searchKeyword: state.query,
          numberOfResults: results.nbHits,
          page: results.page + 1,
          facets: merge({}, facetsRefinements, disjunctiveFacetsRefinements),
          filters: state.filters,
        });
      },
      pushPagination: true,
    }),
  ]);
};

export default {};
